import { trpc } from '@/shared/api';

export const useMyOrderInquiriesQuery = (
  orderId: string,
  options: { readonly enabled?: boolean } = {},
) =>
  trpc.myOrderInquiries.listByOrder.useQuery(
    { orderId },
    { enabled: options.enabled ?? true, retry: false },
  );
